/**
 * Portal ICAVI - Serviço de domínio: Usuários
 * Extraído de apiService.ts para reduzir o tamanho do módulo monolítico (RF-07).
 */
import axios from 'axios';
import { api } from '../apiClient';
export const usuariosServiceMethods = {
    async getUsuarios() {
        try {
            const response = await api.get('/api/usuarios');
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar usuários:', error);
            throw error;
        }
    },
    async getUsuario(userId) {
        try {
            const response = await api.get(`/api/usuario/${userId}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar usuário:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async getMeuUsuario() {
        try {
            const response = await api.get('/api/usuarios/me');
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar perfil do usuário logado:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async updateMeuUsuario(userData) {
        try {
            const response = await api.put('/api/usuarios/me', userData);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar perfil do usuário logado:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async startMeuMfaMethodChange(method, secret) {
        try {
            const response = await api.post('/api/usuarios/me/mfa-method', {
                method,
                ...(secret ? { secret } : {}),
            });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao iniciar alteração do método MFA:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async completeMeuMfaMethodChange(code) {
        try {
            const response = await api.post('/api/usuarios/me/mfa-method/confirm', {
                code,
            });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao confirmar alteração do método MFA:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async rotateMeuMfaRecoveryCodes() {
        try {
            const response = await api.post('/api/usuarios/me/mfa-recovery-codes', {});
            return response.data;
        }
        catch (error) {
            console.error('Erro ao rotacionar códigos de recuperação MFA:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async uploadMeuAvatar(arquivo) {
        try {
            const formData = new FormData();
            formData.append('arquivo', arquivo);
            const response = await api.post('/api/usuarios/me/avatar', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao enviar avatar do usuário:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async removerMeuAvatar() {
        try {
            const response = await api.delete('/api/usuarios/me/avatar');
            return response.data;
        }
        catch (error) {
            console.error('Erro ao remover avatar do usuário:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async getMeuAvatarBlob() {
        try {
            const response = await api.get('/api/usuarios/me/avatar', {
                responseType: 'blob',
            });
            return response.data;
        }
        catch (error) {
            if (axios.isAxiosError(error) && error.response?.status === 404) {
                return null;
            }
            console.error('Erro ao obter avatar do usuário:', error);
            throw error;
        }
    },
    async updateUsuario(userId, userData) {
        try {
            const response = await api.put(`/api/usuario/${userId}`, userData);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar usuário:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async updateUsuarioMfaPolicy(userId, policyData) {
        try {
            const response = await api.patch(`/api/usuario/${userId}/mfa-policy`, policyData);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar política MFA do usuário:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async resetUsuarioMfa(userId) {
        try {
            const response = await api.post(`/api/usuario/${userId}/mfa-reset`, {});
            return response.data;
        }
        catch (error) {
            console.error('Erro ao resetar MFA do usuário:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async deleteUsuario(userId) {
        try {
            const response = await api.delete(`/api/usuario/${userId}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao excluir usuário:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
};
